export default "__VITE_PUBLIC_ASSET__cbd768c3__"